// extracted by mini-css-extract-plugin
module.exports = {"container":"case_study_related_container__bmjdD","content":"case_study_related_content___jHdI"};